<script>
import { menu_url } from "@/api/url";

import styles from "./mainMenu.module.scss";

import { animate } from "../common/js/animate";

import User from "./components/user.vue";

import { mapMutations, mapActions, mapState } from "vuex";
import systemConfig from '@/utils/globalVal.js'

export default {
  name: "main-menu",
  data() {
    return {
      sidearr: [],
    };
  },

  methods: {
    ...mapActions("menu", [
      "setSubmenuList",
      "setMainMenuMovePlace",
      "setCurrentMovePlace",
    ]),
    getMenu() {
      this.$get(menu_url(), {}).then((data) => {
        this.sidearr = data[0]?.children ?? [];
        const dataOne = [this.sidearr[0]];
      });
    },
    onMenuClick(e, index, item) {
      const currentIndex = e.target.getAttribute("data-index");
      const distance = currentIndex * 118 + 172;
      this.setMainMenuMovePlace({ place: distance });
      const moveDom = document.querySelector(".move");
      animate(moveDom, distance, "left");
      this.getChildrenList(currentIndex);
      this.setCurrentMovePlace({ place: 0 });
      const currentHref = this.defaultHref(
        this.sidearr[currentIndex]?.children ?? []
      );
      if (currentHref) {
        this.$router.push(currentHref);
      } else {
        this.$router.push("/main/home");
      }
    },
    defaultHref(c) {
      let currentHref = "";
      (function deep(c) {
        for (let i = 0; i < c.length; i++) {
          if (c[0].children.length === 0) {
            currentHref = c[0].href;
          } else {
            const cc = c[0].children;
            deep(cc);
          }
        }
      })(c);
      return currentHref;
    },
    onMenuOver(e) {
      const el = e.target;
      el.classList.add(styles.active);
    },
    onMenuOut(e) {
      const el = e.target;
      el.classList.remove(styles.active);
    },
    getChildrenList(index) {
      let list = [];
      const tempList = this.sidearr[index]?.children ?? [];
      list = tempList.map((item, i) => {
        return this.setupCurrentMenu(item, i);
      });
      this.setSubmenuList(list);
    },
    setupCurrentMenu(c, index) {
      const len = c.children.length;
      const _this = this;
      c.show = false;
      if (len > 0) {
        if (index === 0) {
          c.show = true;
        }
        c.current = false;
        const tempList = c.children;
        const tempChildren = tempList.map((item, i) => {
          if (index === 0 && i === 0) {
            item.current = true;
          } else {
            item.current = false;
          }
          return item;
        });
        c.children = tempChildren;
        // 点击主菜单，如果子菜单下有已选中的菜单，二级菜单展开，暂未实现
        // const current=tempChildren.findIndex(item=>this.currentSubMenu.id===item.id);
        // if(current!=-1){
        //   c.show=true;
        // }
      } else {
        if (index === 0) {
          c.current = true;
        } else {
          c.current = false;
        }
      }
      return c;
    },
    initMovePlace() {
      let distance = 0;
      if (!this.mainMenuMovePlace) {
        distance = 172;
      } else {
        distance = this.mainMenuMovePlace.place;
      }
      const moveDom = document.querySelector(".move");
      animate(moveDom, distance, "left");
    },
  },
  components: {
    User,
  },
  render() {
 
    const { sidearr, actived } = this;
    const { onMenuOver, onMenuClick, onMenuOut } = this;
    if(this.isFullscreen){
      return null
    }else{
         return (
      <div class={styles["main-menu"]}>
        <div class={styles.logo}>
          <img src={require("@/assets/images/menu_img/logo.png")} />
          <span>{systemConfig.LOGO_NAME}</span>
        </div>
        <div class={styles.menus}>
          <span class={[styles.move, "move"].join(" ")}></span>
          {sidearr.map((item, index) => (
            <span
              data-index={index}
              onMouseover={onMenuOver}
              onMouseout={onMenuOut}
              onClick={(e) => onMenuClick(e, index, item)}
            >
              {item.title}
            </span>
          ))}
        </div>
        <div class={styles.user}>
          <User />
        </div>
      </div>
    );
    }
 
  },
  created(){
    
  },
  mounted() {
    this.getMenu();
    this.initMovePlace();
  },
  computed: {
    ...mapState({
      // list: state => state.menu.subMenuList,
      currentSubMenu: (state) => state.menu.currentSubMenu,
      currentMovePlace: (state) => state.menu.currentMovePlace,
      mainMenuMovePlace: (state) => state.menu.mainMenuMovePlace,
      isFullscreen:(state)=> state.fullscreen.isFullscreen
    }),
  },
};
</script>



